import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import useMedia from "../componentsofcourse/useMedia";
import Select from "react-select";
import "./InternalForm.css";
import EmployeeForm from "./EmployeeForm";
import { Redirect } from "react-router-dom";
import { BASE_URL } from "../env";
const PROJECT_STRUCT = {
	// projectId: "",
	description: "",
	duration: "",
	status: "",
	project: "",
};

const InternalForm = () => {
	// const [additionalProjectsButton, setAdditionalProjectsButton] = useState(
	//   false
	// );
	const [projectCounter, setProjectCounter] = useState([]);
	const [startTime, setStartTime] = useState("");
	const [endTime, setEndTime] = useState("");
	const [department, setDepartment] = useState("");
	const [manager, setManager] = useState("");
	const [internCode, setInternCode] = useState("code");
	const [internId, setInternId] = useState("");
	const [status, setStatus] = useState("");
	const [project, setProject] = useState("");
	const [projectId, setProjectId] = useState("");
	const [description, setDescription] = useState("");
	const [duration, setDuration] = useState("");
	const [data, setData] = useState([]);
	const [dataFromGetIntern, setDataFromGetIntern] = useState([]);
	const [managerOptions, setManagerOptions] = useState([]);
	const [projectOptions, setProjectOptions] = useState([]);
	const [logoutClickedOnInternForm, setLogoutClickedOnInternForm] =
		useState(false);
	const [stTime, setStTime] = useState("");
	const [internLoggedIn, setInternLoggedIn] = useState(false);
	const loginClicked = () => {
		let loginTime = new Date();
		loginTime = loginTime.toLocaleString("en-US", {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});
		console.log(dataFromGetIntern.message.internCode, "Intern Code");
		fetch(BASE_URL + "/addTask", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({
				isLogin: true,
				internCode: dataFromGetIntern.message.internCode,
				reportingManager: "-",
				department: "-",
				startTime: loginTime,
				endTime: "-",
				tasks: [
					{
						project: "",
						duration: "-",
						status: "Ongoing",
						description: "-",
						projectId: "-",
					},
				],
			}),
		})
			.then((res) => res.json())
			.then((data) => {
				console.log("Data from Add Task ", data);
			})
			.then(() => {
				fetch(BASE_URL + "/getInternLogin/", {
					method: "GET",
					headers: {
						"Content-Type": "application/json",
						authorization: localStorage.getItem("token"),
					},
				})
					.then((res) => res.json())
					.then((data) => {
						setDataFromGetIntern(data);
						console.log(
							"Data from Get Intern Login",
							dataFromGetIntern
						);
						console.log("Data from Get Intern Login", data);
						if (data?.message?.isLogin == true) {
							setInternLoggedIn(data.message.isLogin);
							window.location.reload();
							console.log(internLoggedIn);
						} else {
							setInternLoggedIn(data?.message?.isLogin);
							console.log(internLoggedIn);
						}
					});
			})
			.catch((err) => {
				console.log("Error from add task", err);
			});
	};
	useEffect(() => {
		fetch(BASE_URL + "/getInternLogin/", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setDataFromGetIntern(data);
				console.log("Data from Get Intern Login", dataFromGetIntern);
				console.log("Data from Get Intern Login", data);
				setInternCode(data?.message?.internCode);
				if (data?.message?.isLogin == true) {
					setInternLoggedIn(data?.message?.isLogin);
					console.log(internLoggedIn);
				} else {
					setInternLoggedIn(data?.message?.isLogin);
					console.log(internLoggedIn);
				}
				return data;
			})
			.then((tsk) => {
				if (tsk?.task?.startTime !== undefined) {
					setStTime(tsk.task.startTime);
				}
			});
	}, []);
	useEffect(() => {
		fetch(BASE_URL + "/getProfile", {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				//check if user is an intern here.
			});
	}, []);
	const formSubmit = async (e) => {
		e.preventDefault();
		let logoutTime = new Date();
		logoutTime = logoutTime.toLocaleString("en-US", {
			hour: "numeric",
			minute: "numeric",
			hour12: true,
		});
		let addtsk = projectCounter;
		let tsk = [
			{
				project: project.toString(),
				duration,
				description,
				// projectId: projectIdCode + projectId,
				status,
			},
			...addtsk,
		];
		await fetch(BASE_URL + "/updateTask", {
			method: "POST",
			headers: {
				"content-Type": "application/json",
				authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify({
				isLogin: false,
				internCode: internCode,
				startTime: stTime,
				endTime: logoutTime,
				department,
				reportingManager: manager,
				tasks: tsk,
			}),
		}).then(() => {
			fetch(BASE_URL + "/getInternLogin/", {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					authorization: localStorage.getItem("token"),
				},
			})
				.then((res) => res.json())
				.then((data) => {
					setDataFromGetIntern(data);
					console.log(
						"Data from Get Intern Login",
						dataFromGetIntern
					);
					console.log("Data from Get Intern Login", data);
					if (data?.message?.isLogin == true) {
						setInternLoggedIn(data.message.isLogin);
						console.log(internLoggedIn);
					} else {
						setInternLoggedIn(data?.message?.isLogin);
						console.log(internLoggedIn);
					}
				})
				.then(() => {
					setLogoutClickedOnInternForm(false);
				});
		});
		console.log({
			internCode: internCode + internId,
			startTime,
			endTime,
			department,
			reportingManager: manager,
			tasks: tsk,
		});
	};

	const departmentOptions = [
		{ value: "Management", label: "Management" },
		{ value: "Business Analytics B2B", label: "Business Analytics B2B" },
		{ value: "Business Analytics B2C", label: "Business Analytics B2C" },
		{
			value: "Campus Ambassador Program",
			label: "Campus Ambassador Program",
		},
		{
			value: "Corporate Connect Project",
			label: "Corporate Connect Project",
		},
		{ value: "Content Development", label: "Content Development" },
		{ value: "Content Writing", label: "Content Writing" },
		{ value: "CXO Advisory", label: "CXO Advisory" },
		{ value: "Graphic Design", label: "Graphic Design" },
		{ value: "Human Resource", label: "Human Resource" },
		{ value: "Instacks", label: "Instacks" },
		{ value: "Operations", label: "Operations" },
		{ value: "Power BI", label: "Power BI" },
		{ value: "Product Management", label: "Product Management" },
		{ value: "Sales & BD", label: "Sales & BD" },
		{ value: "Social Media", label: "Social Media" },
		{ value: "Web Development", label: "Web Development" },
		{ value: "Resources", label: "Resources" },
	];
	const [projectIdCode, setProjecIdCode] = useState("code");
	useEffect(async () => {
		if (department === "Management") setProjecIdCode("P-MG-");
		if (department === "Business Analytics B2B")
			setProjecIdCode("P-B2B-BA-");
		if (department === "Business Analytics B2C")
			setProjecIdCode("P-B2C-BA-");
		if (department === "Campus Ambassador Program")
			setProjecIdCode("P-CAP-");
		if (department === "Corporate Connect Project")
			setProjecIdCode("P-CCP-");
		if (department === "Content Development") setProjecIdCode("P-CD-");
		if (department === "Content Writing") setProjecIdCode("P-CW-");
		if (department === "CXO Advisory") setProjecIdCode("P-CXOA-");
		if (department === "Graphic Design") setProjecIdCode("P-GD-");
		if (department === "Human Resource") setProjecIdCode("P-HR-");
		if (department === "Instacks") setProjecIdCode("P-INS-");
		if (department === "Operations") setProjecIdCode("P-OPR-");
		if (department === "Power BI") setProjecIdCode("P-PBI-");
		if (department === "Product Management") setProjecIdCode("P-PM-");
		if (department === "Sales & BD") setProjecIdCode("P-S&BD-");
		if (department === "Social Media") setProjecIdCode("P-SM-");
		if (department === "Web Development") setProjecIdCode("P-WD-");
		if (department === "Resources") setProjecIdCode("P-R-");
	}, [department]);

	// useEffect(async () => {
	//   if (department === "Management") setInternCode("MG-IN-");
	//   if (department === "Business Analytics B2B") setInternCode("B2B-IN-BA-");
	//   if (department === "Business Analytics B2C") setInternCode("B2C-IN-BA-");
	//   if (department === "Campus Ambassador Program") setInternCode("CAP-IN-");
	//   if (department === "Corporate Connect Project") setInternCode("CCP-IN-");
	//   if (department === "Content Development") setInternCode("CD-IN-");
	//   if (department === "Content Writing") setInternCode("CW-IN-");
	//   if (department === "CXO Advisory") setInternCode("CXOA-IN-");
	//   if (department === "Graphic Design") setInternCode("GD-IN-");
	//   if (department === "Human Resource") setInternCode("HR-IN-");
	//   if (department === "Instacks") setInternCode("INS-IN-");
	//   if (department === "Operations") setInternCode("OPR-IN-");
	//   if (department === "Power BI") setInternCode("PBI-IN-");
	//   if (department === "Product Management") setInternCode("PM-IN-");
	//   if (department === "Sales & BD") setInternCode("S&BD-IN-");
	//   if (department === "Social Media") setInternCode("SM-IN-");
	//   if (department === "Web Development") setInternCode("WD-IN-");
	//   if (department === "Resources") setInternCode("R-IN-");
	// }, [department]);

	return (
		<>
			<section id="interns-form">
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-10 intern-form-portion mb-0 mx-auto shadow">
							<div className="intern-form-heading">
								Intern Reporting
							</div>
							<div className="row mx-auto">
								<div className="col-6">
									<button
										disabled={internLoggedIn ? true : false}
										onClick={() => {
											loginClicked();
										}}
										className={
											internLoggedIn
												? "submit-intern-form-btn-2 btn-success m-0 disabled"
												: "submit-intern-form-btn-2 btn-success m-0 "
										}
									>
										Login
									</button>
									{stTime && internLoggedIn === true ? (
										<h3
											className="mt-5 "
											style={{ color: "grey" }}
										>
											You logged in at :-{" "}
											<b style={{ color: "#185adb" }}>
												{stTime}
											</b>
										</h3>
									) : (
										""
									)}
								</div>
								<div className="col-6 ">
									<button
										disabled={internLoggedIn ? false : true}
										onClick={() => {
											setLogoutClickedOnInternForm(
												!logoutClickedOnInternForm
											);
										}}
										className={
											internLoggedIn
												? "submit-intern-form-btn-2 btn-danger m-0 disabled"
												: "submit-intern-form-btn-2 btn-danger m-0 "
										}
									>
										Logout
									</button>
								</div>
								{logoutClickedOnInternForm ? (
									<form className="col-12">
										{/* <div className="col-md-6 m-0">
                      <label for="inputWorkStarting" className="form-label">
                        Login time<span className="asterisk">*</span>
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        id="inputWorkStarting"
                        name="startTime"
                        value={startTime}
                        onChange={(event) => {
                          let e = event.target.value;
                          setStartTime(e);
                        }}
                      />
                    </div> */}
										{/* <div className="col-md-6 m-0">
                      <label for="inputWorkEnding" className="form-label">
                        Logout time<span className="asterisk">*</span>
                      </label>
                      <input
                        type="time"
                        className="form-control"
                        id="inputWorkEnding"
                        name="endTime"
                        value={endTime}
                        onChange={(event) => {
                          let e = event.target.value;
                          setEndTime(e);
                        }}
                      />
                    </div> */}
										{/* <div className="col-md-6 m-0">{
                  login?
                  <button className="submit-intern-form-btn mb-2" 
                  onClick={() => setLogin(!login)}>
                    Logout
                  </button>
                  :<button className="submit-intern-form-btn mb-2" 
                  onClick={() => setLogin(!login)}>
                    Login
                  </button>
                }
                </div> */}
										<div className="col-md-12 m-0">
											<label
												for="inputDepartment"
												className="form-label"
											>
												Department
												<span className="asterisk">
													*
												</span>
											</label>
											<Select
												options={departmentOptions}
												className="mb-4"
												name="department"
												value={departmentOptions.find(
													(obj) =>
														obj.value === department
												)}
												onChange={async (event) => {
													setDepartment(event.value);
													// console.log(event.value)
													await fetch(
														BASE_URL +
															"/departmentInfo/" +
															event.value
													)
														.then((res) =>
															res.json()
														)
														.then((data) => {
															console.log(
																data.project
																	.Project
															);
															setData(data);
															let managersTemp =
																	[],
																projectsTemp =
																	[];
															data.project.Project.map(
																(
																	oneProject
																) => {
																	projectsTemp.push(
																		{
																			value: oneProject.name,
																			label: oneProject.name,
																		}
																	);
																}
															);
															setProjectOptions(
																projectsTemp
															);
															console.log(
																projectsTemp
															);

															data.project.Manager.map(
																(
																	oneManager
																) => {
																	managersTemp.push(
																		{
																			value: oneManager,
																			label: oneManager,
																		}
																	);
																}
															);
															setManagerOptions(
																managersTemp
															);

															// data.project.Project.map((oneProject) => {
															//   projectsTemp.push({
															//     value: oneProject.name,
															//     label: oneProject.name,
															//   });
															// });
														});
												}}
											/>
										</div>
										<div className="col-md-12 m-0">
											<label
												for="inputReportingManager"
												className="form-label"
											>
												Reporting Manager
												<span className="asterisk">
													*
												</span>
											</label>
											<Select
												options={managerOptions}
												className="mb-4"
												name="manager"
												value={managerOptions.find(
													(obj) =>
														obj.value === manager
												)}
												onChange={(event) => {
													setManager(event.value);
												}}
											/>
										</div>
										<div className="col-12 m-0">
											<label
												for="inputInternCode"
												className="form-label"
											>
												Intern Code
												<span className="asterisk">
													*
												</span>
											</label>
											{/* <div className="d-flex flex-row"> */}
											<input
												style={{
													color: "grey",
													fontWeight: "bold",
													width: "50%",
												}}
												// onChange={handleCode}
												type="text"
												className="form-control"
												id="inputWorkEnding"
												disabled
												value={internCode}
											/>
											{/* <input
                          type="number"
                          className="form-control"
                          id="inputInternCode"
                          name="internCode"
                          value={internId}
                          onChange={(event) => {
                            let e = event.target.value;
                            setInternId(e);
                          }}
                        /> */}
											{/* </div> */}
										</div>
										{/* <div className="col-12 m-0">
                      <label for="projectId" className="form-label">
                        Project ID<span className="asterisk">*</span>
                      </label>
                      <div className="d-flex flex-row">
                        <input
                          style={{ color: "grey", fontWeight: "bold" }}
                          // onChange={handleCode}
                          type="text"
                          className="form-control"
                          id="inputWorkEnding"
                          disabled
                          value={projectIdCode}
                        />
                        <input
                          type="text"
                          className="form-control"
                          id="projectId"
                          name="projectId"
                          value={projectId}
                          onChange={(event) => {
                            let e = event.target.value;
                            setProjectId(e);
                          }}
                        />
                      </div>
                    </div> */}
										<br />
										<div className="col-12 m-0">
											<label
												for="project"
												className="form-label"
											>
												Projects
												<span className="asterisk">
													*
												</span>
											</label>
											{/* <input
                    type="text"
                    className="form-control"
                    id="project"
                    name="project"
                    value={project}
                    onChange={(event) => {
                      let e = event.target.value;
                      setProject(e);
                    }}
                  /> */}
											<Select
												options={projectOptions}
												className="mb-4"
												name="project"
												value={projectOptions.find(
													(obj) =>
														obj.value === project
												)}
												onChange={(event) => {
													setProject(event.value);
												}}
												// onChange={(value, stat) => {
												//   console.log(1, value, stat);
												//   value.map((val) => {
												//     if (stat.action === "select-option")
												//       setProject([...project, val.value]);
												//     else if (stat.action === "remove-value") {
												//       let temp = [];
												//       project.map((oneProject) => {
												//         console.log(oneProject);
												//         if (oneProject !== stat.removedValue.value)
												//           temp.push(oneProject);
												//       });
												//       setProject(temp);
												//     }
												//   });
												// }}
											/>
										</div>
										<div className="col-12">
											<label
												for="status"
												className="form-label"
											>
												Status
												<span className="asterisk">
													*
												</span>
											</label>
											<br />
											<input
												type="radio"
												className="form-radio"
												id="projects"
												name="status"
												onClick={() =>
													setStatus("Completed")
												}
											/>{" "}
											Completed
											<input
												style={{ marginLeft: "2rem" }}
												type="radio"
												className="form-radio"
												id="status"
												name="status"
												onClick={() =>
													setStatus("Ongoing")
												}
											/>{" "}
											Ongoing
											<input
												style={{ marginLeft: "2rem" }}
												type="radio"
												className="form-radio"
												id="status"
												name="status"
												onClick={() =>
													setStatus("Halted")
												}
											/>{" "}
											Halted
										</div>
										<div className="col-12 m-0">
											<label
												for="duration"
												className="form-label"
											>
												Duration(Minutes)
												<span className="asterisk">
													*
												</span>
											</label>
											<input
												type="number"
												className="form-control"
												id="duration"
												value={duration}
												onChange={(event) => {
													let e = event.target.value;
													setDuration(e);
												}}
											/>
										</div>
										<br />
										<div className="col-12 m-0">
											<label
												for="description"
												className="form-label"
											>
												Description
												<span className="asterisk">
													*
												</span>
											</label>
											<input
												type="text"
												className="form-control"
												id="description"
												value={description}
												onChange={(event) => {
													let e = event.target.value;
													setDescription(e);
												}}
											/>
										</div>
										{/* <div className="col-12 m-0">
                      <label for="projects" className="form-label">
                        Additional Projects<span className="asterisk">*</span>
                      </label>
                      <input
                        type="radio"
                        className="form-radio"
                        id="projects"
                        name="additionalProjects"
                        onClick={() => setAdditionalProjectsButton(true)}
                      />{" "}
                      Yes
                      <input
                        style={{ marginLeft: "1rem" }}
                        type="radio"
                        className="form-radio"
                        id="projects"
                        name="additionalProjects"
                        onClick={() => setAdditionalProjectsButton(false)}
                      />{" "}
                      No
                    </div> */}
										<br />
										<div>
											{projectCounter.map(
												(oneElement, index) => (
													<div
														style={{
															border: "1px solid #999",
														}}
														key={index}
													>
														<div className="col-12">
															<div className="row">
																<div className="col-12 mb-0 mt-3">
																	<label
																		for="projectName"
																		className="form-label"
																	>
																		Project
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																</div>
																<div className="col-md-12 mb-0">
																	<Select
																		options={
																			projectOptions
																		}
																		className="mb-4"
																		name="project"
																		value={projectOptions.find(
																			(
																				obj
																			) =>
																				obj.value ===
																				projectCounter[
																					index
																				]
																					.project
																		)}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								event.value,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									event.value,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									event.value,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								event.value,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																		}}
																	/>
																</div>
																<br />
																{/* <div className="col-12 mb-0 mt-3">
                                <label
                                  for="inputProject"
                                  className="form-label"
                                >
                                  Project Id
                                  <span className="asterisk">*</span>
                                </label>
                              </div>
                              <div className="col-md-12 mb-0">
                                <input
                                  type="text"
                                  className="form-control mb-0"
                                  id="inputAddress2"
                                  placeholder="Project ID"
                                  onChange={(event) => {
                                    if (projectCounter.length === 1) {
                                      setProjectCounter([
                                        {
                                          projectId: event.target.value,
                                          project: oneElement.project,
                                          status: oneElement.status,
                                          duration: oneElement.duration,
                                          description: oneElement.description,
                                        },
                                      ]);
                                    } else if (projectCounter.length === 2) {
                                      if (index === 0) {
                                        setProjectCounter([
                                          {
                                            projectId: event.target.value,
                                            project: oneElement.project,
                                            status: oneElement.status,
                                            duration: oneElement.duration,
                                            description:
                                              oneElement.description,
                                          },
                                          projectCounter[1],
                                        ]);
                                      } else {
                                        setProjectCounter([
                                          projectCounter[0],
                                          {
                                            projectId: event.target.value,
                                            project: oneElement.project,
                                            status: oneElement.status,
                                            duration: oneElement.duration,
                                            description:
                                              oneElement.description,
                                          },
                                        ]);
                                      }
                                    } else {
                                      setProjectCounter([
                                        ...(index === 0
                                          ? []
                                          : projectCounter.slice(0, index)),
                                        {
                                          projectId: event.target.value,
                                          project: oneElement.project,
                                          status: oneElement.status,
                                          duration: oneElement.duration,
                                          description: oneElement.description,
                                        },
                                        ...(index ===
                                        projectCounter.length - 1
                                          ? []
                                          : projectCounter.slice(
                                              index + 1,
                                              projectCounter.length
                                            )),
                                      ]);
                                    }
                                    // console.log(projectCounter)
                                  }}
                                />
                              </div> */}
																<br />
																<div className="col-12">
																	<label
																		for="status"
																		className="form-label"
																	>
																		Status
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<br />
																	<input
																		type="radio"
																		className="form-radio"
																		id="projects"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Completed",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Completed",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Completed",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Completed",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>{" "}
																	Completed
																	<input
																		style={{
																			marginLeft:
																				"2rem",
																		}}
																		type="radio"
																		className="form-radio"
																		id="status"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Ongoing",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Ongoing",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>{" "}
																	Ongoing
																	<input
																		style={{
																			marginLeft:
																				"2rem",
																		}}
																		type="radio"
																		className="form-radio"
																		id="status"
																		name={
																			"status" +
																			index
																		}
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Halted",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Halted",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: "Halted",
																								duration:
																									oneElement.duration,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: "Halted",
																							duration:
																								oneElement.duration,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																		}}
																	/>{" "}
																	Halted
																</div>
																<div className="col-md-12 m-0">
																	<label
																		for="duration"
																		className="form-label"
																	>
																		Duration(Minutes)
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<input
																		type="number"
																		className="form-control"
																		id="duration"
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								event
																									.target
																									.value,
																							description:
																								oneElement.description,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									event
																										.target
																										.value,
																								description:
																									oneElement.description,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									event
																										.target
																										.value,
																								description:
																									oneElement.description,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								event
																									.target
																									.value,
																							description:
																								oneElement.description,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>
																</div>
																<div className="col-md-12 m-0">
																	<label
																		for="desc"
																		className="form-label"
																	>
																		Description
																		<span className="asterisk">
																			*
																		</span>
																	</label>
																	<input
																		type="text"
																		row="2"
																		className="form-control"
																		id="desc"
																		onChange={(
																			event
																		) => {
																			if (
																				projectCounter.length ===
																				1
																			) {
																				setProjectCounter(
																					[
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								event
																									.target
																									.value,
																						},
																					]
																				);
																			} else if (
																				projectCounter.length ===
																				2
																			) {
																				if (
																					index ===
																					0
																				) {
																					setProjectCounter(
																						[
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									event
																										.target
																										.value,
																							},
																							projectCounter[1],
																						]
																					);
																				} else {
																					setProjectCounter(
																						[
																							projectCounter[0],
																							{
																								// projectId: oneElement.projectId,
																								project:
																									oneElement.project,
																								status: oneElement.status,
																								duration:
																									oneElement.duration,
																								description:
																									event
																										.target
																										.value,
																							},
																						]
																					);
																				}
																			} else {
																				setProjectCounter(
																					[
																						...(index ===
																						0
																							? []
																							: projectCounter.slice(
																									0,
																									index
																							  )),
																						{
																							// projectId: oneElement.projectId,
																							project:
																								oneElement.project,
																							status: oneElement.status,
																							duration:
																								oneElement.duration,
																							description:
																								event
																									.target
																									.value,
																						},
																						...(index ===
																						projectCounter.length -
																							1
																							? []
																							: projectCounter.slice(
																									index +
																										1,
																									projectCounter.length
																							  )),
																					]
																				);
																			}
																			// console.log(projectCounter)
																		}}
																	/>
																</div>
															</div>
														</div>
													</div>
												)
											)}
										</div>
										<div className="btn-group my-2">
											<button
												type="button"
												style={{ width: "3rem" }}
												className="add-btn"
												onClick={() =>
													setProjectCounter([
														...projectCounter,
														PROJECT_STRUCT,
													])
												}
											>
												+
											</button>
											{projectCounter.length > 0 ? (
												<button
													type="button"
													style={{ width: "3rem" }}
													className="sub-btn"
													onClick={() =>
														setProjectCounter([
															...projectCounter.slice(
																0,
																projectCounter.length -
																	1
															),
														])
													}
												>
													-
												</button>
											) : (
												""
											)}
										</div>
										<br />
										<div className="col-12">
											<button
												type="submit"
												className="submit-intern-form-btn"
												onClick={formSubmit}
											>
												submit
											</button>
										</div>
									</form>
								) : null}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

function ProjectForm() {
	const departmentOptions = [
		{ value: "Management", label: "Management" },
		{ value: "Business Analytics B2B", label: "Business Analytics B2B" },
		{ value: "Business Analytics B2C", label: "Business Analytics B2C" },
		{
			value: "Campus Ambassador Program",
			label: "Campus Ambassador Program",
		},
		{
			value: "Corporate Connect Project",
			label: "Corporate Connect Project",
		},
		{ value: "Content Development", label: "Content Development" },
		{ value: "Content Writing", label: "Content Writing" },
		{ value: "CXO Advisory", label: "CXO Advisory" },
		{ value: "Graphic Design", label: "Graphic Design" },
		{ value: "Human Resource", label: "Human Resource" },
		{ value: "Instacks", label: "Instacks" },
		{ value: "Operations", label: "Operations" },
		{ value: "Power BI", label: "Power BI" },
		{ value: "Product Management", label: "Product Management" },
		{ value: "Sales & BD", label: "Sales & BD" },
		{ value: "Social Media", label: "Social Media" },
		{ value: "Web Development", label: "Web Development" },
		{ value: "Resources", label: "Resources" },
	];
	const [department, setDepartment] = useState("");
	const [name, setProjectNam] = useState("");
	const [projectId, setProjecId] = useState("");
	const [projectIdCode, setProjecIdCode] = useState("code");
	const [Manager, setManager] = useState("");
	const [managerOptions, setManagerOptions] = useState([]);

	function handleProjectName(event) {
		let nam = event.target.value;
		setProjectNam(nam);
	}
	function handleProjectId(event) {
		let cod = event.target.value;
		setProjecId(cod);
		// console.log(projectid);
	}

	useEffect(async () => {
		if (department === "Management") setProjecIdCode("P-MG-");
		if (department === "Business Analytics B2B")
			setProjecIdCode("P-B2B-BA-");
		if (department === "Business Analytics B2C")
			setProjecIdCode("P-B2C-BA-");
		if (department === "Campus Ambassador Program")
			setProjecIdCode("P-CAP-");
		if (department === "Corporate Connect Project")
			setProjecIdCode("P-CCP-");
		if (department === "Content Development") setProjecIdCode("P-CD-");
		if (department === "Content Writing") setProjecIdCode("P-CW-");
		if (department === "CXO Advisory") setProjecIdCode("P-CXOA-");
		if (department === "Graphic Design") setProjecIdCode("P-GD-");
		if (department === "Human Resource") setProjecIdCode("P-HR-");
		if (department === "Instacks") setProjecIdCode("P-INS-");
		if (department === "Operations") setProjecIdCode("P-OPR-");
		if (department === "Power BI") setProjecIdCode("P-PBI-");
		if (department === "Product Management") setProjecIdCode("P-PM-");
		if (department === "Sales & BD") setProjecIdCode("P-S&BD-");
		if (department === "Social Media") setProjecIdCode("P-SM-");
		if (department === "Web Development") setProjecIdCode("P-WD-");
		if (department === "Resources") setProjecIdCode("P-R-");
	}, [department]);

	async function handleSubmit(event) {
		event.preventDefault();
		const respo = {
			Department: department,
			Manager,
			Project: { name, projectId: projectIdCode + projectId },
		};
		console.log(respo);

		await fetch(BASE_URL + "/newProject", {
			method: "POST",
			headers: {
				"content-Type": "application/json",
				authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify(respo),
		})
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				// setInte([...inte,data.results]);
			});
	}

	return (
		<>
			<section id="interns-form">
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-10 intern-form-portion mb-0 mx-auto shadow">
							<div className="intern-form-heading">
								Add Project
							</div>
							<form
								className="row g-3 interns-form"
								onSubmit={handleSubmit}
							>
								<div className="col-md-12 m-0">
									<label
										for="inputDepartment"
										className="form-label"
									>
										Department
										<span className="asterisk">*</span>
									</label>
									<Select
										options={departmentOptions}
										className="mb-4"
										name="department"
										value={departmentOptions.find(
											(obj) => obj.value === department
										)}
										onChange={async (event) => {
											setDepartment(event.value);
											// console.log(event.value)
											await fetch(
												BASE_URL +
													"/departmentInfo/" +
													event.value
											)
												.then((res) => res.json())
												.then((data) => {
													let managersTemp = [];

													data.project.Manager.map(
														(oneManager) => {
															managersTemp.push({
																value: oneManager,
																label: oneManager,
															});
														}
													);
													setManagerOptions(
														managersTemp
													);
												});
										}}
									/>
								</div>
								<div className="col-md-12 m-0">
									<label
										for="inputManager"
										className="form-label"
									>
										Manager
										<span className="asterisk">*</span>
									</label>
									<Select
										options={managerOptions}
										className="mb-4"
										name="inputManager"
										value={managerOptions.find(
											(obj) => obj.value === Manager
										)}
										onChange={(event) => {
											setManager(event.value);
										}}
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkStarting"
										className="form-label"
									>
										Project Name
										<span className="asterisk">*</span>
									</label>
									<input
										onChange={handleProjectName}
										type="text"
										className="form-control"
										id="inputWorkStarting"
										name="startTime"
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkEnding"
										className="form-label"
									>
										Project Id
										<span className="asterisk">*</span>
									</label>
									<div className="d-flex flex-row">
										<input
											style={{
												color: "grey",
												fontWeight: "bold",
											}}
											onChange={handleProjectId}
											type="text"
											className="form-control"
											id="inputWorkEnding"
											value={projectIdCode}
											disabled
										/>
										<input
											onChange={handleProjectId}
											type="text"
											className="form-control"
											id="inputWorkEnding"
										/>
									</div>
								</div>
								<div className="col-12">
									<button
										type="submit"
										className="submit-intern-form-btn"
									>
										submit
									</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

function InternForm() {
	const departmentOptions = [
		{ value: "Management", label: "Management" },
		{ value: "Business Analytics B2B", label: "Business Analytics B2B" },
		{ value: "Business Analytics B2C", label: "Business Analytics B2C" },
		{
			value: "Campus Ambassador Program",
			label: "Campus Ambassador Program",
		},
		{
			value: "Corporate Connect Project",
			label: "Corporate Connect Project",
		},
		{ value: "Content Development", label: "Content Development" },
		{ value: "Content Writing", label: "Content Writing" },
		{ value: "CXO Advisory", label: "CXO Advisory" },
		{ value: "Graphic Design", label: "Graphic Design" },
		{ value: "Human Resource", label: "Human Resource" },
		{ value: "Instacks", label: "Instacks" },
		{ value: "Operations", label: "Operations" },
		{ value: "Power BI", label: "Power BI" },
		{ value: "Product Management", label: "Product Management" },
		{ value: "Sales & BD", label: "Sales & BD" },
		{ value: "Social Media", label: "Social Media" },
		{ value: "Web Development", label: "Web Development" },
		{ value: "Resources", label: "Resources" },
	];
	const [department, setDepartment] = useState("");
	const [InternCode, setInternCode] = useState("code");
	const [InternEmail, setInternEmail] = useState("");

	useEffect(async () => {
		if (department === "Management") setInternCode("MG-IN-");
		if (department === "Business Analytics B2B")
			setInternCode("B2B-IN-BA-");
		if (department === "Business Analytics B2C")
			setInternCode("B2C-IN-BA-");
		if (department === "Campus Ambassador Program")
			setInternCode("CAP-IN-");
		if (department === "Corporate Connect Project")
			setInternCode("CCP-IN-");
		if (department === "Content Development") setInternCode("CD-IN-");
		if (department === "Content Writing") setInternCode("CW-IN-");
		if (department === "CXO Advisory") setInternCode("CXOA-IN-");
		if (department === "Graphic Design") setInternCode("GD-IN-");
		if (department === "Human Resource") setInternCode("HR-IN-");
		if (department === "Instacks") setInternCode("INS-IN-");
		if (department === "Operations") setInternCode("OPR-IN-");
		if (department === "Power BI") setInternCode("PBI-IN-");
		if (department === "Product Management") setInternCode("PM-IN-");
		if (department === "Sales & BD") setInternCode("S&BD-IN-");
		if (department === "Social Media") setInternCode("SM-IN-");
		if (department === "Web Development") setInternCode("WD-IN-");
		if (department === "Resources") setInternCode("R-IN-");
	}, [department]);
	const [inte, setInte] = useState([]);
	useEffect(async () => {
		await fetch(BASE_URL + "/getAllInterns", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setInte(data.results);
				// setAdmin(data.user.isAdmin)
			});
	}, []);

	const [nam, setNam] = useState("");
	const [cod, setCod] = useState("");

	function handleName(event) {
		let nam = event.target.value;
		setNam(nam);
	}
	function handleCode(event) {
		let cod = event.target.value;
		setCod(cod);
	}
	function handleEmail(event) {
		let email = event.target.value;
		setInternEmail(email);
	}

	async function handleSubmit1(event) {
		event.preventDefault();

		await fetch(BASE_URL + "/newIntern", {
			method: "POST",
			headers: {
				"content-Type": "application/json",
				authorization: localStorage.getItem("token"),
			},
			body: JSON.stringify({
				name: nam,
				internCode: InternCode + cod,
				email: InternEmail,
				department,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				setInte([...inte, data.results]);
			});
	}

	return (
		<>
			<section id="interns-form">
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-10 intern-form-portion mb-0 mx-auto shadow">
							<div className="intern-form-heading">
								Add Intern
							</div>
							<form
								className="row g-3 interns-form"
								onSubmit={handleSubmit1}
							>
								<div className="col-md-12 m-0">
									<label
										for="inputDepartment"
										className="form-label"
									>
										Department
										<span className="asterisk">*</span>
									</label>
									<Select
										options={departmentOptions}
										className="mb-4"
										name="department"
										value={departmentOptions.find(
											(obj) => obj.value === department
										)}
										onChange={(event) => {
											setDepartment(event.value);
										}}
										Required
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkStarting"
										className="form-label"
									>
										Intern Name
										<span className="asterisk">*</span>
									</label>
									<input
										onChange={handleName}
										type="text"
										className="form-control"
										id="InterName"
										name="InterName"
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkEnding"
										className="form-label"
									>
										Intern Code
										<span className="asterisk">*</span>
									</label>
									<div className="d-flex flex-row">
										<input
											style={{
												color: "grey",
												fontWeight: "bold",
											}}
											onChange={handleCode}
											type="text"
											className="form-control"
											id="inputWorkEnding"
											disabled
											value={InternCode}
										/>
										<input
											onChange={handleCode}
											type="text"
											className="form-control"
											id="inputWorkEnding"
										/>
									</div>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkEnding"
										className="form-label"
									>
										Intern Email
										<span className="asterisk">*</span>
									</label>
									<div className="d-flex flex-row">
										<input
											onChange={handleEmail}
											type="text"
											className="form-control"
											id="inputWorkEnding"
										/>
									</div>
								</div>
								{/* <div className="col-md-3 m-0"> */}
								{/* </div> */}
								<div className="col-12">
									<button
										type="submit"
										className="submit-intern-form-btn"
									>
										submit
									</button>
								</div>
							</form>
							<table className="table table-striped">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Inter Name</th>
										<th scope="col">Intern Code</th>
									</tr>
								</thead>
								<tbody>
									{inte.map((intern, i) => {
										return (
											<tr key={i}>
												<th scope="row">{i + 1}</th>
												<td>{intern.name}</td>
												<td>{intern.internCode}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

function EmployeeAddForm() {
	const departmentOptions = [
		{ value: "Management", label: "Management" },
		{ value: "Business Analytics B2B", label: "Business Analytics B2B" },
		{ value: "Business Analytics B2C", label: "Business Analytics B2C" },
		{
			value: "Campus Ambassador Program",
			label: "Campus Ambassador Program",
		},
		{
			value: "Corporate Connect Project",
			label: "Corporate Connect Project",
		},
		{ value: "Content Development", label: "Content Development" },
		{ value: "Content Writing", label: "Content Writing" },
		{ value: "CXO Advisory", label: "CXO Advisory" },
		{ value: "Graphic Design", label: "Graphic Design" },
		{ value: "Human Resource", label: "Human Resource" },
		{ value: "Instacks", label: "Instacks" },
		{ value: "Operations", label: "Operations" },
		{ value: "Power BI", label: "Power BI" },
		{ value: "Product Management", label: "Product Management" },
		{ value: "Sales & BD", label: "Sales & BD" },
		{ value: "Social Media", label: "Social Media" },
		{ value: "Web Development", label: "Web Development" },
		{ value: "Resources", label: "Resources" },
	];
	const [department, setDepartment] = useState("");
	const [InternCode, setInternCode] = useState("code");

	useEffect(async () => {
		if (department === "Management") setInternCode("MG-EP-");
		if (department === "Business Analytics B2B")
			setInternCode("B2B-EP-BA-");
		if (department === "Business Analytics B2C")
			setInternCode("B2C-EP-BA-");
		if (department === "Campus Ambassador Program")
			setInternCode("CAP-EP-");
		if (department === "Corporate Connect Project")
			setInternCode("CCP-EP-");
		if (department === "Content Development") setInternCode("CD-EP-");
		if (department === "Content Writing") setInternCode("CW-EP-");
		if (department === "CXO Advisory") setInternCode("CXOA-EP-");
		if (department === "Graphic Design") setInternCode("GD-EP-");
		if (department === "Human Resource") setInternCode("HR-EP-");
		if (department === "Instacks") setInternCode("INS-EP-");
		if (department === "Operations") setInternCode("OPR-EP-");
		if (department === "Power BI") setInternCode("PBI-EP-");
		if (department === "Product Management") setInternCode("PM-EP-");
		if (department === "Sales & BD") setInternCode("S&BD-EP-");
		if (department === "Social Media") setInternCode("SM-EP-");
		if (department === "Web Development") setInternCode("WD-EP-");
		if (department === "Resources") setInternCode("R-EP-");
	}, [department]);
	const [inte, setInte] = useState([]);
	useEffect(async () => {
		await fetch(BASE_URL + "/getAllEmployees", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => res.json())
			.then((data) => {
				setInte(data.results);
				// setAdmin(data.user.isAdmin)
			});
	}, []);

	const [nam, setNam] = useState("");
	const [cod, setCod] = useState("");
	const [emails, setEmails] = useState("");

	function handleName(event) {
		let nam = event.target.value;
		setNam(nam);
	}
	function handleEmail(event) {
		let email = event.target.value;
		setEmails(email);
	}
	function handleCode(event) {
		let cod = event.target.value;
		setCod(cod);
	}

	async function handleSubmit1(event) {
		event.preventDefault();

		await fetch(BASE_URL + "/newEmployee", {
			method: "POST",
			headers: {
				"content-Type": "application/json",
				authorization: "Bearer " + localStorage.getItem("token"),
			},
			body: JSON.stringify({
				name: nam,
				email: emails,
				depart: department,
				employeeCode: InternCode + cod,
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				setInte([...inte, data.results]);
			});
	}

	return (
		<>
			<section id="interns-form">
				<div className="container-fluid p-0">
					<div className="row">
						<div className="col-md-10 intern-form-portion mb-0 mx-auto shadow">
							<div className="intern-form-heading">
								Add Employee
							</div>
							<form
								className="row g-3 interns-form"
								onSubmit={handleSubmit1}
							>
								<div className="col-md-12 m-0">
									<label
										for="inputDepartment"
										className="form-label"
									>
										Department
										<span className="asterisk">*</span>
									</label>
									<Select
										options={departmentOptions}
										className="mb-4"
										name="department"
										value={departmentOptions.find((obj) => {
											return obj.value === department;
										})}
										onChange={(event) => {
											setDepartment(event.value);
										}}
										Required
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkStarting"
										className="form-label"
									>
										Name<span className="asterisk">*</span>
									</label>
									<input
										onChange={handleName}
										type="text"
										className="form-control"
										id="InterName"
										name="InterName"
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkStarting"
										className="form-label"
									>
										Email<span className="asterisk">*</span>
									</label>
									<input
										onChange={handleEmail}
										type="text"
										className="form-control"
										id="InterName"
										name="InterName"
									/>
								</div>
								<div className="col-md-6 m-0">
									<label
										for="inputWorkEnding"
										className="form-label"
									>
										Employee Code
										<span className="asterisk">*</span>
									</label>
									<div className="d-flex flex-row">
										<input
											style={{
												color: "grey",
												fontWeight: "bold",
											}}
											onChange={handleCode}
											type="text"
											className="form-control"
											id="inputWorkEnding"
											disabled
											value={InternCode}
										/>
										<input
											onChange={handleCode}
											type="text"
											className="form-control"
											id="inputWorkEnding"
										/>
									</div>
								</div>
								{/* <div className="col-md-3 m-0"> */}

								{/* </div> */}
								<div className="col-12">
									<button
										type="submit"
										className="submit-intern-form-btn"
									>
										submit
									</button>
								</div>
							</form>
							<table className="table table-striped">
								<thead>
									<tr>
										<th scope="col">#</th>
										<th scope="col">Employee Name</th>
										<th scope="col">Email</th>
										<th scope="col">Department</th>
										<th scope="col">Employee Code</th>
									</tr>
								</thead>
								<tbody>
									{inte.map((intern, i) => {
										return (
											<tr key={i}>
												<th scope="row">{i + 1}</th>
												<td>{intern.name}</td>
												<td>{intern.email}</td>

												<td>{intern.depart}</td>
												<td>{intern.employeeCode}</td>
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</section>
		</>
	);
}

function DailyReportForm() {
	return (
		<>
			<h1>Daily Report Form</h1>
		</>
	);
}

function InternalFormPage({ history }) {
	const matches = useMedia("(max-width : 575px )");
	const [formId, setFormId] = useState(0);
	const [admin, setAdmin] = useState(false);
	const [user, setUser] = useState(true);
	const [load, setLoad] = useState(false);

	const dashboardListWithAdmin = [
		<InternalForm />,
		<EmployeeForm />,
		<ProjectForm />,
		<InternForm />,
		<EmployeeAddForm />,
		//  <DailyReportForm />
	];
	const dashboardTitleListWithAdmin = [
		"Intern Reporting",
		"Employee Attendance",
		"Project",
		"Intern",
		"Employee",
		// "DailyReport"
	];
	const dashboardListWithoutAdmin = [<InternalForm />, <EmployeeForm />];
	const dashboardTitleListWithoutAdmin = [
		"Intern Attendance",
		"Employee Attendance",
	];

	const dashboardList = admin
		? dashboardListWithAdmin
		: dashboardListWithoutAdmin;
	const dashboardTitleList = admin
		? dashboardTitleListWithAdmin
		: dashboardTitleListWithoutAdmin;

	useEffect(async () => {
		await fetch(BASE_URL + "/getProfile", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("token"),
			},
		})
			.then((res) => {
				if (res.status !== 200) {
					setLoad(true);
					return {
						user: {
							isAdmin: false,
						},
					};
				} else {
					setLoad(false);
					setUser(false);
					return res.json();
				}
			})
			.then((data) => {
				if (!load) setAdmin(data.user.isAdmin);
			});
	}, []);

	return (
		<>
			{load ? (
				<Redirect to="/signin" />
			) : (
				<>
					<Navbar />
					{matches ? (
						<div
							style={{
								width: "100%",
								height: "100vh",
								overflowX: "hidden",
								overflowY: "scroll",
							}}
						>
							<div
								className="row"
								style={{
									width: "100%",
									height: "auto",
									overflow: "hidden",
								}}
							>
								<div
									className="col-12 mx-auto my-2"
									style={{ overflow: "hidden" }}
								>
									<ul className="list-group">
										{dashboardTitleList.map(
											(oneTitle, index) => {
												return (
													<li
														key={index}
														onClick={() =>
															setFormId(index)
														}
														style={{
															width: "100%",
															fontSize: "1.1rem",
														}}
														className={
															"m-1 list-group-item " +
															(formId === index
																? "active"
																: "")
														}
													>
														{oneTitle}
													</li>
												);
											}
										)}
									</ul>
								</div>
							</div>
							<div className="row">
								<div
									className="col-12"
									style={{
										overflowY: "scroll",
										height: "100%",
									}}
								>
									{dashboardList[formId]}
								</div>
							</div>
						</div>
					) : (
						<div
							style={{
								width: "100%",
								height: "100vh",
								overflow: "hidden",
							}}
						>
							<div
								className="d-flex flex Row"
								style={{
									width: "100%",
									height: "100vh",
									position: "absolute",
									overflow: "hidden",
								}}
							>
								<div
									className="col-3 m-2"
									style={{ overflow: "hidden" }}
								>
									<ul className="list-group">
										{dashboardTitleList.map(
											(oneTitle, index) => {
												return (
													<li
														key={index}
														onClick={() =>
															setFormId(index)
														}
														style={{
															width: "100%",
															fontSize: "1.1rem",
														}}
														className={
															"m-1 list-group-item " +
															(formId === index
																? "active"
																: "")
														}
													>
														{oneTitle}
													</li>
												);
											}
										)}
									</ul>
								</div>
								<div
									className="col-9"
									style={{
										overflowY: "scroll",
										height: "100%",
									}}
								>
									{dashboardList[formId]}
								</div>
							</div>
						</div>
					)}
				</>
			)}
		</>
	);
}

export default InternalFormPage;
